import React, { useEffect } from "react";
import { Modal, Form, DatePicker, Button, Typography, Alert } from "antd";
import moment from "moment";

const { Text } = Typography;

const ModalApproveHmo = ({ visible, onClose, onSubmit, user, loading }) => {
  const [form] = Form.useForm();

  useEffect(() => {
    if (visible) {
      form.resetFields();
      // Default to 3 months from today
      form.setFieldsValue({
        hmo_expires_at: moment().add(3, "months"),
      });
    }
  }, [visible, form]);

  const handleFinish = async (values) => {
    await onSubmit({
      hmo_expires_at: values.hmo_expires_at.format("YYYY-MM-DD"),
    });
  };

  return (
    <Modal
      title="Approve HMO Registration"
      visible={visible}
      onCancel={onClose}
      footer={null}
      destroyOnClose
    >
      {user && (
        <div style={{ marginBottom: "16px" }}>
          <Alert
            message={`Approving HMO for ${user.name}`}
            description={
              <div>
                <p style={{ margin: "4px 0" }}>
                  <strong>HMO Provider:</strong> {user.hmo?.name || "N/A"}
                </p>
                <p style={{ margin: "4px 0" }}>
                  <strong>HMO Number:</strong> {user.hmo_number || "N/A"}
                </p>
                <p style={{ margin: "4px 0" }}>
                  <strong>Email:</strong> {user.email}
                </p>
                <Text type="secondary" style={{ fontSize: "12px" }}>
                  An approval notification email will automatically be sent to the user upon approval.
                </Text>
              </div>
            }
            type="info"
            showIcon
          />
        </div>
      )}

      <Form form={form} layout="vertical" onFinish={handleFinish}>
        <Form.Item
          name="hmo_expires_at"
          label="HMO Expiration Date"
          rules={[{ required: true, message: "Please choose an expiration date" }]}
          extra="You can extend or update this date at any time."
        >
          <DatePicker
            style={{ width: "100%" }}
            disabledDate={(current) => current && current < moment().startOf("day")}
            format="YYYY-MM-DD"
            getPopupContainer={(trigger) => trigger.parentNode}
            popupStyle={{ zIndex: 3000 }}
            dropdownClassName="hmo-datepicker-dropdown"
          />
        </Form.Item>

        <div style={{ display: "flex", justifyContent: "flex-end", gap: "10px", marginTop: "24px" }}>
          <Button onClick={onClose}>Cancel</Button>
          <Button type="primary" htmlType="submit" loading={loading} style={{ background: "#27ae60", borderColor: "#27ae60" }}>
            Confirm & Approve
          </Button>
        </div>
      </Form>
    </Modal>
  );
};

export default ModalApproveHmo;
